const testRegex = (regex: RegExp, target: string): boolean => {
  return regex.test(target);
};

/**
 * 이메일 아이디 validation
 * @param email
 */
const emailValidation = (email: string | null | undefined): boolean => {
  if (!email || email.trim().length === 0) {
    return false;
  }
  const regex = /^([\w.-]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,})$/;
  return testRegex(regex, email as string);
};

/**
 * 패스워드 validation
 * 대소문자 영문 + 숫자 조합 => 3이상
 * @param password
 */
const passwordValidation = (password: string | null | undefined) => {
  if (!password || password.trim().length === 0) {
    return false;
  }
  const regex = /(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d[`~!@#$%^&*()\-_=+{\]}\\|;:'",<.>/?]{3,}$/;
  return testRegex(regex, password as string);
};

/**
 * 이름/성 validation - trim 후 유니코드 문자(letter)가 하나 이상 포함되어야 통과
 * 공백/특수문자/기호로만 구성된 값은 차단 (하이픈, 아포스트로피 등 특수문자 혼용은 허용)
 * @param name
 */
const nameValidation = (name: string | null | undefined): boolean => {
  if (!name) {
    return false;
  }
  const regex = /\p{L}/u;
  return testRegex(regex, name.trim());
};

export {
  emailValidation,
  passwordValidation,
  nameValidation
};